import React, { Component, Fragment } from "react";
import Breadcrumb from "../../common/breadcrumb";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import Datatable from "./employeeDatatable";

import { getAllEmployeeRedux } from "../../../actions/index";
import { Link } from "react-router-dom";
import CreateDocumentModal from "./createDocumentModal";
import { connect } from "react-redux";
import "./employee.css";

export class Employee extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      toggleModal: true,
      employee: null,
    };
  }

  componentDidMount = async () => {
    this.props.getAllEmployeeRedux();
  };

  startToggleModal = async (employeeObj) => {
    if (employeeObj == null) {
      this.setState({ toggleModal: !this.state.toggleModal, employee: null });
    } else {
      this.setState({
        toggleModal: !this.state.toggleModal,
        employee: employeeObj,
      });
    }
  };

  render() {
    const { open } = this.state;

    console.log(this.props);
    return (
      <Fragment>
        <CreateDocumentModal
          toggleModal={this.state.toggleModal}
          startToggleModal={this.startToggleModal}
          employee={this.state.employee}
        />
        <Breadcrumb title="Employees" parent="Cash in/out" />
        {/* <!-- Container-fluid starts--> */}
        <div className="container-fluid em-page kd-cash kd-st--sky">
          <div className="row">
            <div className="col-sm-12">
              <div className="card em-card">
                <div className="card-header em-card-header" style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                  <h5 className="em-card-title">
                    <i className="icofont-building em-card-icon"></i>
                    Employees
                  </h5>
                  <button
                    className="btn em-add-btn"
                    type="button"
                    onClick={() => this.startToggleModal(null)}
                  >
                    <i className="fa fa-plus" aria-hidden="true"></i> Add employee
                  </button>
                </div>
                <div className="card-body">
                  <div className="clearfix"></div>
                  <div id="basicScenario" className="product-physical">
                    <Datatable
                      startToggleModal={this.startToggleModal}
                      history={this.props.history}
                      multiSelectOption={false}
                      myData={this.props.allEmployees}
                      pageSize={50}
                      pagination={true}
                      class="-striped -highlight"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
        {/* <!-- Container-fluid Ends--> */}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    allEmployees: state.employees.employees,
  };
};

export default connect(mapStateToProps, {
  getAllEmployeeRedux,
})(Employee);
